const paymetMethods = {
  1: "credit_card",
  2: "pix",
  3: "bank_slip",
};

export { paymetMethods };
